







































import { Vue, Component, Prop } from "vue-property-decorator";
import { ClientFormData } from "@/types";
import FieldItem from "./FieldItem.vue";
import PreviewModal from "../../preview-modal/PreviewModal.vue";

export interface IFormSection {
  title: string;
  data: ClientFormData[];
  class?: string;
}

@Component({
  components: {
    FieldItem,
    PreviewModal,
  },
})
export default class FormSection extends Vue {
  @Prop({ type: Array, default: () => [] })
  leftData!: IFormSection[];
  @Prop({ type: Array, default: () => [] })
  rightData!: IFormSection[];
  @Prop(String)
  columnClass?: string;

  showPreview = false;
  previewImage = "";
  previewTitle = "";

  get displayData() {
    return [this.leftData, this.rightData];
  }

  setPreviewModal(open: boolean, title?: string, imageUrl?: string) {
    this.showPreview = open;
    this.previewImage = imageUrl || "";
    this.previewTitle = title || "";
  }

  handleClickFile(fileUrl: string, title: string) {
    this.setPreviewModal(true, title, fileUrl);
  }
}
